import { j as m } from "./jsx-runtime-944c88e2.js";
import * as n from "react";
import { v as L, d as k, m as D, a as S, r as h, c as _, g as U, I as F, p as M, U as N } from "./Upload-6f10e2c7.js";
import { p as l } from "./index-efd35e77.js";
import { L as P } from "./index.es-6889c727.js";
import { c as K, S as G } from "./index-93802845.js";
import "./Button-4c83e316.js";
import "./package-metadata-9ad1330d.js";
import "./index-64063129.js";
import "./theme-b013fa81.js";
import "./ProgressBar-f33eeff2.js";
import "./index-c07310bf.js";
import "react-dom";
import "./auto-scroll-b2de6e53.js";
var O = 100, E = n.forwardRef(function(e, v) {
  L(M);
  var c = n.useRef(null), u = n.useRef(null), s = n.useRef(null), d = n.useRef(!1), i = n.useRef(null), r = e.uploadRef, a = r.current, o = n.useState(!1), z = o[0], p = o[1], R = n.useMemo(function() {
    return new K("en");
  }, []), g = G(), I = g.toLanguageString(k, D[k]), b = n.useState(g.toLanguageString(S, D[S])), T = b[0], C = b[1], Z = e.customHint || n.createElement("span", null, I), w = e.customNote || n.createElement("span", null, T), y = n.useCallback(function() {
    u.current && u.current.focus();
  }, [u]);
  n.useImperativeHandle(c, function() {
    return {
      element: u.current,
      focus: y,
      props: e
    };
  }), n.useImperativeHandle(v, function() {
    return c.current;
  }), n.useEffect(function() {
    if (a) {
      var t = a.props.restrictions.allowedExtensions;
      if (t && t.length) {
        var f = R.format(g.toLanguageString(h, D[h]), [
          t
        ]);
        C(f);
      }
    }
  }, [a, g, R]);
  var x = n.useCallback(function(t) {
    return (/* @__PURE__ */ new Date()).getTime() - (t || /* @__PURE__ */ new Date()).getTime() > O;
  }, []), H = n.useCallback(function(t) {
    t.preventDefault();
    var f = t.dataTransfer.files;
    f.length > 0 && !e.disabled && r && r.current && (r.current.onAdd && (t.preventDefault(), r.current.onAdd(f)), e.onDrop && e.onDrop.call(void 0, t));
  }, [e.disabled, r, e.onDrop]), j = n.useCallback(function(t) {
    if (d) {
      d.current = !0;
      var f = function() {
        x(i.current) && (p(!1), d.current = !1, clearInterval(s.current), s.current = null, i.current = null);
      };
      s.current = setInterval(f, O);
    }
    e.onElementDragEnter && e.onElementDragEnter.call(void 0, t);
  }, [d, s, i, x, e.onElementDragEnter]), A = n.useCallback(function(t) {
    t.preventDefault(), i.current = /* @__PURE__ */ new Date(), p(!0), e.onElementDragOver && e.onElementDragOver.call(void 0, t);
  }, [i, e.onElementDragOver]);
  return n.createElement(
    "div",
    { ref: u, id: e.id, className: _("k-external-dropzone", {
      "k-external-dropzone-hover": z,
      "k-disabled": e.disabled
    }, e.className), tabIndex: U(e.tabIndex, e.disabled, void 0), onDrop: H, onDragEnter: j, onDragOver: A },
    n.createElement(
      "div",
      { style: e.style, className: "k-dropzone-inner" },
      n.createElement(F, { name: "upload", icon: P, className: "k-dropzone-icon", size: "xxxlarge" }),
      n.createElement("span", { className: "k-dropzone-hint" }, Z),
      n.createElement("span", { className: "k-dropzone-note" }, w)
    )
  );
}), V = {
  id: l.string,
  tabIndex: l.number,
  editorRef: l.oneOfType([
    l.func,
    l.shape({ current: l.any })
  ]),
  disabled: l.bool,
  onDrop: l.func,
  onElementDragEnter: l.func,
  onElementDragOver: l.func
};
E.displayName = "KendoReactExternalDropZone";
E.propTypes = V;
const oe = (e) => {
  const [v, c] = n.useState([]), u = (r) => {
    var a, o;
    c(r.newState), (o = (a = e.upload) == null ? void 0 : a.onAdd) == null || o.call(a, r);
  }, s = (r) => {
    var a, o;
    c(r.newState), (o = (a = e.upload) == null ? void 0 : a.onRemove) == null || o.call(a, r);
  }, d = (r) => {
    var a, o;
    c(r.newState), (o = (a = e.upload) == null ? void 0 : a.onProgress) == null || o.call(a, r);
  }, i = (r) => {
    var a, o;
    c(r.newState), (o = (a = e.upload) == null ? void 0 : a.onStatusChange) == null || o.call(a, r);
  };
  if (e.dropZoneVisible) {
    const r = n.createRef();
    return /* @__PURE__ */ m.jsxs(m.Fragment, { children: [
      /* @__PURE__ */ m.jsx(E, { customHint: "Drag and drop files here", uploadRef: r, ...e.dropzone }),
      /* @__PURE__ */ m.jsx(
        N,
        {
          files: v,
          onAdd: u,
          onRemove: s,
          onProgress: d,
          onStatusChange: i,
          ref: r,
          ...e.upload
        }
      )
    ] });
  }
  return /* @__PURE__ */ m.jsx(
    N,
    {
      files: v,
      onAdd: u,
      onRemove: s,
      onProgress: d,
      onStatusChange: i,
      ...e.upload
    }
  );
};
export {
  oe as Uploader
};
